/* @ngInject */
function asDate() {
  return {
    require: 'ngModel',
    link: (scope, element, attrs, modelCtrl) => {
      modelCtrl.$formatters.push((input) => {
        const isDefaultDateRequired = attrs.asDateOptional !== 'true';
        let transformedInput = null;

        if (input) {
          transformedInput = new Date(input);
        } else if (isDefaultDateRequired) {
          transformedInput = new Date();
        }

        if (transformedInput !== input) {
          modelCtrl.$setViewValue(transformedInput);
          modelCtrl.$render();
        }

        return transformedInput;
      });
    },
  };
}

export default asDate;



// WEBPACK FOOTER //
// ./client/components/as-date/as-date.directive.js